import styled from 'styled-components';

export const StyledFooterCopyright = styled.div`
  .copyright {
    padding: 24px 0;
    background: ${({ theme }) => theme.colors.black};
    text-align: center;
  }
`;
